import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable } from "rxjs";
import type { Property, UpdatePropertyInput } from "src/app/schema";
import { ApiService } from "src/app/services";

@Injectable({
	providedIn: "root",
})
export class PropertyService {
	private readonly _api = inject(ApiService);
	private readonly _httpClient = inject(HttpClient);

	public getProperty(propertyId: string): Observable<Property> {
		return this._httpClient.get<Property>(
			`${this._api.coreApiEndpoint}/property/${propertyId}`,
		);
	}

	public updateProperty(property: UpdatePropertyInput): Observable<Property> {
		return this._httpClient.put<Property>(
			`${this._api.coreApiEndpoint}/property`,
			property,
		);
	}

	public deleteProperty(propertyId: string): Observable<{ id: string }> {
		return this._httpClient.delete<{ id: string }>(
			`${this._api.coreApiEndpoint}/property/${propertyId}`,
		);
	}
}
